<template>
  <div class="order-detail">
    <!--标题-->
    <div class="breadcrumb">订单详情</div>
    <div class="rg-cn">
      <h3 class="dialog-title">
        <p><span></span>订单信息</p>
      </h3>
      <div class="dialog-content">
        <el-table :data="[orderDetail]" border="" style="width: 100%">
          <el-table-column prop="orderNo" label="订单号"></el-table-column>
          <el-table-column label="淘宝订单号" v-if="$route.query.outType">
            <template v-slot="scope">
              <span>{{ scope.row.outOrderNo ? scope.row.outOrderNo.split(',')[1] : scope.row.outOrderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="subOrderCount" label="总计数量"></el-table-column>
          <el-table-column prop="userName" label="用户名"></el-table-column>
          <el-table-column prop="storeCode" label="平台号"></el-table-column>
          <el-table-column prop="storeName" label="平台名称"></el-table-column>
          <el-table-column prop="storeType" label="平台类型">
            <!-- <template slot-scope="scope"> {{ $config.storeType[scope.row.storeType] }} </template> --> <template slot-scope="scope"> {{ storeType[scope.row.storeType] }} </template>
          </el-table-column>
          <el-table-column prop="salesman" label="业务"></el-table-column>
          <el-table-column prop="dateSubmitted" label="创建日期"></el-table-column>
          <el-table-column prop="datePayment" label="支付日期"></el-table-column>
          <!-- <el-table-column prop="" label="平台价格"></el-table-column> -->
          <el-table-column prop="paymentType" label="支付方式">
            <template slot-scope="scope"> {{ $config.paymentType[scope.row.paymentType] }} </template>
          </el-table-column>
          <el-table-column prop="paymentStatus" label="订单状态">
            <template slot-scope="scope"> {{ $config.orderStatus[scope.row.orderStatus] }} </template>
          </el-table-column>
          <el-table-column label="操作" v-if="orderDetail.paymentStatus !== 'UNPAID'">
            <template slot-scope="scope">
              <span v-if="$hasPermission('oms:admin:orderRefund:apply')" :class="!orderDetail.isShowExpressFee ? 'color-blue' : ''"
                @click="!orderDetail.isShowExpressFee ? $router.push({ path: '/refund/express-fee', query: { priceReal: orderDetail.priceReal, userId: scope.row.userId, orderNo: scope.row.orderNo, refundId: '', storeCode: scope.row.storeCode, storeName: scope.row.storeName } }) : ''">订单扣费<br></span>
              <span :class="!orderDetail.isShowRebate ? 'color-blue' : ''" v-if="orderDetail.orderStatus === 'COMPLETED' && $hasPermission('oms:admin:orderRefund:apply')"
                @click="!orderDetail.isShowRebate ? $router.push({ path: '/refund/rebate', query: { priceReal: orderDetail.priceReal, storeCode: scope.row.storeCode, storeName: scope.row.storeName, orderNo: scope.row.orderNo, refundId: '', storeCode: scope.row.storeCode, storeName: scope.row.storeName } }) : ''">订单返款<br></span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-form ref="form" :model="storeInfo" label-width="150px">
          <el-form-item label="平台号：">
            <span>{{storeInfo.storeCode}}</span>
          </el-form-item>
          <el-form-item label="平台名称：">
            <span>{{storeInfo.storeName}}</span>
          </el-form-item>
          <el-form-item label="手机号：">
            <span>{{storeInfo.storePhone}}</span>
          </el-form-item>
          <el-form-item label="地址：">
            <span>{{storeInfo.storeAddress}}</span>
          </el-form-item>
        </el-form> -->
      </div>
    </div>
    <div class="rg-cn" style="margin:20px 0;">
      <h3 class="dialog-title">
        <p><span></span>任务信息</p>
      </h3>
      <div class="dialog-content">
        <el-table border :data="orderDetail.subOrders" style="width: 100%" default-expand-all>
          <el-table-column type="expand">
            <template v-slot='scope' class="inner">
              <div style="width:100%;height:100%">
                <el-table border :data="scope.row.orderItems">
                  <el-table-column label="任务号" prop="orderItemNo"></el-table-column>
                  <el-table-column label="sku名称" prop="skuName"></el-table-column>
                  <el-table-column label="属性组合" prop="skuGroupName"></el-table-column>
                  <el-table-column label="产品类型">
                    <template slot-scope="scope">{{ $config.spuType[scope.row.itemType] }}</template>
                  </el-table-column>
                  <el-table-column label="P数" prop="page"></el-table-column>
                  <el-table-column label="数量">
                    <template slot-scope="scope">
                      <span>{{ $route.query.outType ? scope.row.itemQuantity : scope.row.quantity }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="任务状态">
                    <template slot-scope="scope">
                      <p>{{ $config.orderItemStatus[scope.row.orderItemStatus] }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="快递追踪">
                    <template v-slot="scope1">
                      <el-button v-if="scope1.row.expresses.length != 0" @click="getExpressDetail(scope1.row.expresses, $msg.filterBridal(scope.row.address.phone))" type="text" size="small">快递追踪
                      </el-button>
                      <div>{{ scope1.row.expresses[0] ? scope1.row.expresses[0].trackNo : '' }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="合成文件">
                    <template v-slot="scope">
                      <el-button v-if="scope.row.orderItemStatus === 'RENDER_DONE' && (scope.row.itemType !== 'SAMPLE' && scope.row.itemType !== 'NORMAL')" @click="getRenderPdf(scope.row.orderItemNo)"
                        type="text" size="small">查看合成 </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="子订单号" prop="suborderNo"></el-table-column>
          <el-table-column label="子订单号" prop="suborderNo"></el-table-column>
          <el-table-column label="产品名称" prop="spuName"></el-table-column>
          <el-table-column label="属性组合" prop="skuGroupName"></el-table-column>
          <el-table-column label="数量" prop="quantity">
          </el-table-column>
          <el-table-column label="价格" prop="onlinePrice"></el-table-column>
          <el-table-column label="会员价" prop="price"></el-table-column>
          <el-table-column label="申请支付价格" prop="applyPayPrice"></el-table-column>
          <el-table-column label="初创平台价格" prop="startupsPrice"></el-table-column>
          <el-table-column label="零售价" prop="cprice" v-if="type == 'TokerOrder' && !$route.query.outType"></el-table-column>
          <!-- <el-table-column label="实付单价" prop="price">
            <template slot-scope="scope"> {{ scope.row.order.paymentStatus === 'UNPAID' ? '0' : scope.row.order.promoCode ? orderDetail.priceReal : orderDetail.payerType === 'USER' ? scope.row.cprice
                : (scope.row.paymentType === 'VP_ACCT' || scope.row.paymentType === 'VP_SETTLE' || scope.row.paymentType === 'VP_BONUS') ? scope.row.price : scope.row.onlinePrice
            }} </template>
          </el-table-column>
          <el-table-column label="实付总价" prop="priceTotal">
            <template slot-scope="scope"> {{ scope.row.order.paymentStatus === 'UNPAID' ? '0' : scope.row.order.promoCode ? orderDetail.priceReal : orderDetail.payerType === 'USER' ?
                scope.row.cpriceTotal : (scope.row.paymentType === 'VP_ACCT' || scope.row.paymentType === 'VP_SETTLE' || scope.row.paymentType === 'VP_BONUS') ? scope.row.priceTotal :
                  scope.row.onlinePriceTotal
            }} </template>
          </el-table-column> -->
          <el-table-column label="客户名称" prop="personalMessage"></el-table-column>
          <el-table-column label="收货人" prop="address.person"></el-table-column>
          <el-table-column label="收货电话" prop="address.phone">
            <template slot-scope="scope">{{ $msg.filterBridal(scope.row.address.phone) }}</template>
          </el-table-column>
          <el-table-column label="收货地址" prop="address.completeAddress">
          </el-table-column>
          <el-table-column v-if="$hasPermission('oms:admin:suborder:address')" label="操作">
            <template slot-scope="scope">
              <el-button v-if="orderDetail.orderStatus === 'SUBMITTED' || orderDetail.orderStatus === 'PROCESSING'" @click="modifyAddress(scope.row)" type="text" size="small">修改收货信息 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="height: 50px;width: 100%;"></div>
    <div style="float:left;margin-left:60px;" v-if="orderDetail.remark">备注:{{ orderDetail.remark }}</div>
    <div class="dialog-bottom" v-if="$hasPermission('oms:admin:orderDiscount:audit') && $route.query.way === '2' && orderDiscount !== undefined && orderDiscount.auditStatus === 'APPLY'"> 会员总价: <span
        style="margin-right:20px;">￥{{ orderDetail.priceTotalFree }}</span>
      <!-- 申请价格总计: <el-input v-model="discountAmount" type="number"
        :disabled="$route.query.way === '2'" style="width: 120px;margin-right: 20px;">
      </el-input> -->申请支付价格:<span style="margin-right:20px;">￥{{ orderDiscount.discountAmount }}</span>
      <el-button round @click="auditStatus = 'REJECTED', checkDialog = true">审核拒绝</el-button>
      <el-button type="primary" round @click="clickAuditStatus()">审核通过</el-button>
    </div>
    <div class="dialog-bottom" v-if="$route.query.way === '2' && (orderDiscount.auditStatus === 'REJECTED' || orderDiscount.auditStatus === 'AUDITED')">
      <el-button round @click="$router.go(-1)" type="primary">返回</el-button>
    </div>
    <div class="dialog-bottom" v-if="$route.query.way === '1'"></div>
    <div class="dialog-bottom" v-if="$route.query.way === '1' && orderDetail.orderStatus === 'SUBMITTED'"><span> 会员价：{{ orderDetail.priceTotal }}，满减：{{ orderDetail.discountAmountTotal }}，运费：{{
      orderDetail.channel == 'B2B' ? orderDetail.fee : 0 }} </span><span style="margin-left:20px;">会员总价： </span>
      <el-input v-if="type == 'TokerOrder'" v-model="orderDetail.priceTotalFree" type="number" :min="0" :disabled="orderDiscount ? orderDiscount.auditStatus === 'APPLY' : false"
        style="width: 120px;margin-right: 20px;"></el-input>
      <el-input v-else v-model="orderDetail.priceTotalFree" type="number" :min="0" :disabled="orderDiscount ? orderDiscount.auditStatus === 'APPLY' : false" style="width: 120px;margin-right: 20px;">
      </el-input>
      <!-- <span style="margin-right:20px">￥{{orderDetail.priceReal}}</span> -->
      <el-button
        v-if="$hasPermission('oms:admin:order:cancel') && (orderDetail.orderStatus === 'SUBMITTED' || orderDetail.orderStatus === 'CONFIRMED' || orderDetail.orderStatus === 'PROCESSING' || orderDetail.orderStatus === 'RENDER_DONE')"
        round @click="cancelOrder" type="primary">取消订单 </el-button>
      <el-button v-if="$hasPermission('oms:admin:orderDiscount:apply') &&
        (orderDetail.orderStatus === 'SUBMITTED' && orderDetail.paymentStatus === 'UNPAID' ||
          orderDetail.paymentStatus === 'FAILED')" type="primary" round @click="showChangePriceApply" :disabled="orderDetail.isShowVP">余额支付申请 </el-button>
      <el-button round @click="$router.go(-1)" type="primary">返回</el-button>
    </div>
    <div class="dialog-bottom" v-if="$route.query.way === '1' && orderDetail.orderStatus !== 'SUBMITTED'"><span> 会员价：{{ orderDetail.priceTotal }}，满减：{{ orderDetail.discountAmountTotal }}，运费：{{
      orderDetail.channel == 'B2B' ? orderDetail.fee : 0 }} </span><span style="margin-right: 50px;margin-left: 20px;">会员总价：{{ orderDetail.priceTotalFree }}</span>
      <el-button
        v-if="$hasPermission('oms:admin:order:cancel') && (orderDetail.orderStatus === 'SUBMITTED' || orderDetail.orderStatus === 'CONFIRMED' || orderDetail.orderStatus === 'PROCESSING' || orderDetail.orderStatus === 'RENDER_DONE')"
        round @click="cancelOrder" type="primary">取消订单 </el-button>
      <!-- <el-input v-model="orderDetail.priceReal" type="number" disabled style="width: 120px;margin-right: 20px;"></el-input> -->
      <el-button round @click="$router.go(-1)" type="primary">返回</el-button>
    </div>
    <express-dialog ref="expressDialogRef"></express-dialog>
    <!-- 修改当前收货地址 -->
    <!-- <choice-address @addAddress='addAddress' @changeAddress='changeAddress' ref="choiceAddressRef"></choice-address> -->
    <!-- 添加收货地址到客户地址列表 -->
    <add-address @choiceAdd='choiceAdd' ref="addressRef"></add-address>
    <!-- 修改地址 -->
    <el-dialog :close-on-click-modal="false" title="收货地址" :visible.sync="dialogVisible" @closed='closed' width="45%">
      <el-form ref="form" inline :model="userAddressVo" :hide-required-asterisk="true" :rules="addressRules" label-width="80px">
        <div>
          <el-form-item label="收货人:" prop="person">
            <el-input v-model="userAddressVo.person" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="phone">
            <el-input v-model="userAddressVo.phone"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="地址信息:">
          <el-form-item label="" label-width="0" style="margin:0" prop="sheng">
            <el-select v-model="selectAddress.sheng" value-key="code" @change="getAllshi" clearable>
              <el-option v-for="(option, index) in address.sheng" :key="'provinces' + index" :value="option" :label="option.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" label-width="0" style="margin:0" prop="shi">
            <el-select v-model="selectAddress.shi" style="margin:0 10px" value-key="id" @change="getAllQu" clearable>
              <el-option v-for="(option, index) in address.shi" :key="'city' + index" :value="option" :label="option.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" label-width="0" style="margin:0" prop="qu">
            <el-select v-model="selectAddress.qu" value-key="id" clearable>
              <el-option v-for="(option, index) in address.qu" :key="'region' + index" :value="option" :label="option.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item label="详细地址:" prop="fullAddress">
          <el-input v-model="userAddressVo.fullAddress" style="width:560px;" maxlength="30"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveEditAddress">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="checkDialog" width="30%">
      <span>{{ auditStatus === 'AUDITED' ? '是否确认审核通过呢呢？' : '是否确认审核拒绝呢呢？' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialog = false">取 消</el-button>
        <el-button type="primary" @click="auditDiscount(auditStatus)">确 定</el-button>
      </span>
    </el-dialog>
    <RenderDialog ref="renderDialogRef"></RenderDialog>
  </div>
</template>
<script>
import AddAddress from '@/components/Dialog/AddAddressDialog/index.vue'
import ExpressDialog from '@/components/Dialog/ExpressDialog/index'
import RenderDialog from '@/components/Dialog/OrderDialog/RenderDialog/index.vue'
import { adminOrder, adminOrderCancel, orderPriceApply, auditDiscount, suborderAddress } from '@/api/oms'
import { updateAddress, updateOrderAddress, addressGetCountyByCityId, addressGetCityByProvinceCode, addressGetAllProvince, storeTypeGetStoreTypeList } from '@/api/crm'
import { getByStoreIds } from '@/api/epay'
export default {
  name: 'order-detail',
  components: {
    ExpressDialog,
    AddAddress,
    RenderDialog
  },
  data () {
    var checkSheng = (rule, value, callback) => {
      if (this.selectAddress.sheng === '') {
        callback(new Error('未选择省'))
      } else {
        callback()
      }
    }
    var checkShi = (rule, value, callback) => {
      if (this.selectAddress.shi === '') {
        callback(new Error('未选择市'))
      } else {
        callback()
      }
    }
    var checkQu = (rule, value, callback) => {
      if (this.selectAddress.qu === '') {
        callback(new Error('未选择区'))
      } else {
        callback()
      }
    }
    return {
      auditType: 'VP_ACCT',
      addressRules: {
        person: [
          { required: true, message: '请输入收货人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        sheng: [
          { validator: checkSheng, trigger: 'change' }
        ],
        shi: [
          { validator: checkShi, trigger: 'change' }
        ],
        qu: [
          { validator: checkQu, trigger: 'change' }
        ],
        fullAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ]
      },
      type: this.$route.query.type,
      auditStatus: '',
      checkDialog: false,
      address: {
        sheng: [],
        shi: [],
        qu: []
      },
      selectAddress: {
        sheng: '',
        shi: '',
        qu: ''
      },
      userAddressVo: {
        city: '',
        cityId: '',
        county: '',
        countyId: '',
        fullAddress: '',
        person: '',
        phone: '',
        province: '',
        provinceCode: '',
        userId: ''
      },
      dialogVisible: false,
      orderDiscount: this.$route.query.orderDiscount,
      id: this.$route.query.orderNo,
      orderDetail: {},
      storeInfo: {},
      changeSuborderId: '',
      storeType: [] // 平台类型
    }
  },
  created () {
    console.log('11111', this.$hasPermission('oms:admin:orderDiscount:audit'))
    storeTypeGetStoreTypeList().then(res => {
      this.storeType = []
      let storeTypeData = res.data.data
      const montage = (storeTypeData) => {
        let obj = {}
        for (let v of storeTypeData) {
          obj[v.code] = v.name
        }
        return obj
      }
      this.storeType = montage(storeTypeData)
    })
    this.getOrderDetail()
    this.getAllSheng()
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    async clickAuditStatus () {
      let storeId = this.orderDetail.storeId
      await getByStoreIds(storeId).then((res) => {
        if (res.data.success) {
          // "VPAY_ACCOUNT": "充值余额",
          // "VPAY_BONUS": "礼金券",
          // "VPAY_SETTLE": "结算余额"
          console.log('this.orderDiscount.discountAmount', this.orderDiscount.discountAmount)
          let balance1 = res.data.data?.balances.ACCT?.balance
          let balance2 = res.data.data?.balances.BONUS?.balance
          let balance3 = res.data.data?.balances.SETTLE?.balance
          // 申请支付价格小于充值余额
          if ((balance1 > 0 && (this.orderDiscount.discountAmount < balance1 || this.orderDiscount.discountAmount == balance1)) || balance2 > 0 || balance3 > 0 || this.orderDiscount.discountAmount == 0) {
            this.auditStatus = 'AUDITED'
            this.auditType = (balance1 || this.orderDiscount.discountAmount == 0) ? 'VP_ACCT' : balance2 ? 'VP_BONUS' : balance3 ? 'VP_SETTLE' : ''
            this.checkDialog = true
          } else {
            this.$message.error('平台余额不足，审核失败')
          }
        }
      })
    },
    closed () {
      this.$refs.form.resetFields()
    },
    cancelOrder () {
      this.$confirm('此操作将取消该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminOrderCancel(this.$route.query.orderNo).then(res => {
          if (res.data.success === true) {
            this.$notify({
              title: '操作成功',
              message: '取消该订单成功',
              type: 'success'
            })
            this.getOrderDetail()
          }
        })
      })
    },
    getOrderDetail () {
      adminOrder(this.$route.query.orderNo).then(res => {
        if (res.data.success) {
          let obj = res.data.data
          obj.userName = this.$msg.filterBridal(res.data.data.userName)
          // obj.orderDiscount = obj.orderDiscount ? obj.orderDiscount : { auditStatus: '' }
          let priceTotalFree = (this.type == 'TokerOrder') ? obj.channel == 'B2B' ? parseFloat((obj.priceTotal + obj.fee).toFixed(2)) : obj.priceTotal : parseFloat((obj.priceReal).toFixed(2))
          this.orderDetail = {
            ...obj,
            priceTotalFree: priceTotalFree
          }
          console.log('this.orderDetail', this.orderDetail)
          // this.storeInfo = {
          //   storeCode: this.orderDetail.storeCode,
          //   storeName: this.orderDetail.storeName,
          //   storePhone: this.orderDetail.storePhone,
          //   storeAddress: this.orderDetail.storeAddress
          // }
        }
      })
    },
    getNewAddress (val) {
      this.basicInfo.username = val[0]
      this.basicInfo.phone = val[5]
      this.basicInfo.address = val[1] + '省 ' + val[2] + '市 ' + val[3] + ' ' + val[4]
    },
    showChangePriceApply () {
      if (this.orderDetail.priceReal > 0) {
        if (!this.$reg.priceYue.reg.test(this.orderDetail.priceReal)) {
          this.$message.error('支付金额' + this.$reg.priceYue.message)
          return
        }
      }
      const h = this.$createElement
      this.$confirm(h('p', null, [
        h('span', null, '申请余额支付:'),
        // h('span', { style: 'color: red;margin-left: 6px;margin-right: 6px; font-weight: bold;' }, this.type == 'TokerOrder' ? this.orderDetail.priceTotal : this.orderDetail.priceReal),
        h('span', { style: 'color: red;margin-left: 6px;margin-right: 6px; font-weight: bold;' }, this.orderDetail.priceTotalFree),
        h('span', null, '是否确定申请余额支付？')
      ]), '确认提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        orderPriceApply({
          orderNo: this.id,
          // discountPrice: this.type == 'TokerOrder' ? this.orderDetail.priceTotal : this.orderDetail.priceReal
          discountPrice: this.orderDetail.priceTotalFree
        }).then(res => {
          if (res.data.success) {
            this.$notify({
              title: '操作成功',
              message: '余额支付申请成功',
              type: 'success'
            })
            this.getOrderDetail()
          }
        })
      })
    },
    saveEditAddress () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        let userAddressVo = {
          city: this.selectAddress.shi.name,
          cityId: this.selectAddress.shi.id,
          county: this.selectAddress.qu.name,
          countyId: this.selectAddress.qu.id,
          fullAddress: this.userAddressVo.fullAddress,
          person: this.userAddressVo.person,
          phone: this.userAddressVo.phone,
          province: this.selectAddress.sheng.name,
          provinceCode: this.selectAddress.sheng.code
          // id: this.userAddressVo.id
        }
        updateOrderAddress(userAddressVo).then(res => {
          if (res.data.success) {
            suborderAddress({ params: { addressId: res.data.data.id }, suborderId: this.changeSuborderId }).then(res => {
              if (res.data.success) {
                this.$message.success('修改收货信息成功')
                // this.$notify({
                //   title: '操作成功',
                //   message: '修改收货信息成功',
                //   type: 'success'
                // })
                this.getOrderDetail()
                this.dialogVisible = false
              }
            })
          }
        })
      })
      // updateAddress(userAddressVo).then(res => {
      //   if (res.data.success) {
      //     this.$message.success('修改成功')
      //     this.getOrderDetail()
      //     this.dialogVisible = false
      //   }
      // })
    },
    modifyAddress (row) {
      this.userAddressVo = row.address
      this.userAddressVo.phone = this.$msg.filterBridal(row.address.phone)
      this.selectAddress = {
        sheng: {
          code: row.address.provinceCode,
          name: row.address.province
        },
        shi: {
          id: row.address.cityId,
          name: row.address.city
        },
        qu: {
          id: row.address.countyId,
          name: row.address.county
        }
      }
      if (row.address.provinceCode) {
        this.getAllshi()
      }
      if (row.address.cityId) {
        this.getAllQu()
      }
      this.changeSuborderId = row.suborderId
      this.dialogVisible = true
      // this.$refs.choiceAddressRef.show(row.suborderId, this.orderDetail.userId)
    },
    getExpressDetail (expresses, phone) {
      this.$refs.expressDialogRef.show(expresses[0], phone)
    },
    choiceAdd () {
      this.$refs.ChoiceAddress.show('add')
    },
    addAddress (index) {
      this.$refs.addressRef.show('add', '', index)
    },
    changeAddress (subOrderId, address) {
      let subOrder = this.orderDetail.subOrders.filter((subOrder1) => {
        return subOrder1.suborderId === subOrderId
      })[0]
      address.id = subOrder.addressId
      updateAddress(JSON.stringify(address)).then(res => {
        if (res.data.success === true) {
          this.$notify({
            title: '操作成功',
            message: '修改收货信息成功',
            type: 'success'
          })
          this.orderDetail.subOrders.filter(subOrder => subOrderId === subOrder.suborderId)
            .forEach(subOrder => {
              subOrder.address = address
            })
        }
      })
    },
    getAllQu () {
      if (this.selectAddress.shi === '') {
        this.selectAddress.qu = ''
        return
      }
      addressGetCountyByCityId(this.selectAddress.shi.id).then(res => {
        if (res.data.success) {
          this.address.qu = res.data.data
          if (res.data.data.filter(item => { return item.id === this.selectAddress.qu.id }).length === 0) {
            this.selectAddress.qu = res.data.data[0]
          }
        }
      })
    },
    getAllshi () {
      if (this.selectAddress.sheng === '') {
        this.selectAddress.shi = ''
        this.selectAddress.qu = ''
        return
      }
      addressGetCityByProvinceCode(this.selectAddress.sheng.code).then(res => {
        if (res.data.success) {
          this.address.shi = res.data.data
          if (res.data.data.filter(item => { return item.id === this.selectAddress.shi.id }).length === 0) {
            this.selectAddress.shi = res.data.data[0]
            this.selectAddress.qu = ''
            this.getAllQu()
          }
        }
      })
    },
    getAllSheng () {
      addressGetAllProvince().then(res => {
        if (res.data.success) {
          this.address.sheng = res.data.data
        }
      })
    },
    auditDiscount (auditStatus) {
      console.log('拒绝审核')
      auditDiscount({
        auditStatus: auditStatus,
        orderId: this.id,
        type: this.auditType
      }).then(res => {
        if (res.data.success) {
          this.$message.success('审核成功')
          this.checkDialog = false
          this.$router.go('-1')
          // this.getOrderDetail()
        }
      })
    },
    getRenderPdf (itemId) {
      this.$refs.renderDialogRef.show(itemId)
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.dialog-title {
  margin-bottom: 15px;
  height: 78px;
  background: inherit;
  background-color: rgba(250, 250, 250, 1);
  position: relative;

  p {
    line-height: 78px;
    padding-left: 50px;

    span {
      position: relative;
      top: -2px;
      display: inline-block;
      background: #409eff;
      width: 7px;
      height: 18px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
}

.dialog-content {
  margin: 0 60px;
}

.dialog-bottom {
  width: calc(100% - 230px);
  margin-right: 55px;
  margin-bottom: 10px;
  text-align: right;
  position: fixed;
  bottom: 10px;
  right: 0;
  z-index: 1000;
  background-color: #fff;
}

@{deep} .el-table__expanded-cell {
  box-shadow: -6px -2px 11px 0px #ccc inset;
}

/deep/.is-disabled {
  background-color: #C0C4CC !important;
  border-color: #EBEEF5 !important;
  color: #fff !important;
}
</style>
